import { render, staticRenderFns } from "./OnlyFooter.vue?vue&type=template&id=03ee94c5&scoped=true&lang=pug&"
import script from "./OnlyFooter.vue?vue&type=script&lang=js&"
export * from "./OnlyFooter.vue?vue&type=script&lang=js&"
import style0 from "./OnlyFooter.styl?vue&type=style&index=0&id=03ee94c5&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03ee94c5",
  null
  
)

export default component.exports